import { useState, useEffect } from 'react';
import { teacherAssignments as teacherAssignmentsQuery } from 'legacy-src/queries';
import { getActiveSubject } from 'legacy-src/reducers/subject';

// hooks for getting all teacher assignment
const useGetAssignments = ({ client, router, userData }) => {
  const [state, setState] = useState({
    teacherAssignments: {},
    refetchTeacherAssignments: () => {},
    loadingAssignments: true,
  });
  const { subject: subjectId } = router.params;

  useEffect(() => {
    async function getAssignments(subjects) {
      const response = await client.query({
        query: teacherAssignmentsQuery,
        fetchPolicy: 'network-only',
        variables: {
          subjectIds: subjects.map((subject) => subject.initId) || [],
        },
      });

      const { teacherAssignments, refetch } = response.data;
      setState({
        teacherAssignments,
        refetchTeacherAssignments: refetch,
        loadingAssignments: false,
      });
    }

    const subjectData = getActiveSubject(userData, router.params);
    const { subjects = [] } = subjectData || {};
    if (subjects.length > 0) {
      getAssignments(subjects);
    }
  }, [subjectId]);

  return {
    ...state,
  };
};

export default useGetAssignments;
